/**
 *  @class
 *  @function FacetsToggle
 */

class FacetsToggle {

  constructor() {

    this.container =
      document.getElementById(
        'Facet-Drawer'
      );

    const buttons =
      document.querySelectorAll(
        '#Facets-Toggle'
      );


    buttons.forEach(
      (button) => {

        if (
          button.dataset.facetsToggleBound ===
          'true'
        ) {
          return;
        }

        button.dataset.facetsToggleBound =
          'true';


        button.addEventListener(
          'click',
          (event) => {

            event.preventDefault();


            const body =
              document.body;


            body.classList.toggle(
              'open-cc'
            );


            if (this.container) {

              this.container.classList.toggle(
                'active'
              );

            }

          }
        );

      }
    );


    setTimeout(
      () => {

        window.dispatchEvent(
          new Event(
            'resize.resize-select'
          )
        );

      },
      10
    );

  }

}


/**
 *  @class
 *  @function FacetFiltersForm
 */

class FacetFiltersForm extends HTMLElement {

  constructor() {

    super();


    this.onActiveFilterClick =
      this.onActiveFilterClick.bind(
        this
      );


    this.debouncedOnSubmit =
      debounce(
        (event) => {

          this.onSubmitHandler(
            event
          );

        },
        500
      );


    const form =
      this.querySelector(
        'form'
      );


    if (!form) {
      return;
    }


    /*
     * Shopify/Reformation uses the form's
     * input event for checkboxes, selects
     * and price inputs.
     */

    form.addEventListener(
      'input',
      this.debouncedOnSubmit.bind(
        this
      )
    );


    /*
     * Select elements can sometimes be
     * more reliable with change as well.
     */

    form.addEventListener(
      'change',
      this.debouncedOnSubmit.bind(
        this
      )
    );

  }


  /**
   * ----------------------------------------------------------
   * GLOBAL LISTENERS
   * ----------------------------------------------------------
   */

  static setListeners() {

    const onHistoryChange =
      (event) => {

        const searchParams =
          event.state &&
          typeof event.state.searchParams ===
            'string'
            ? event.state.searchParams
            : FacetFiltersForm.searchParamsInitial;


        if (
          searchParams ===
          FacetFiltersForm.searchParamsPrev
        ) {
          return;
        }


        FacetFiltersForm.renderPage(
          searchParams,
          null,
          false
        );

      };


    window.addEventListener(
      'popstate',
      onHistoryChange
    );

  }


  /**
   * ----------------------------------------------------------
   * DISABLE / ENABLE ACTIVE FILTER LINKS
   * ----------------------------------------------------------
   */

  static toggleActiveFacets(
    disable = true
  ) {

    document
      .querySelectorAll(
        '.js-facet-remove'
      )
      .forEach(
        (element) => {

          element.classList.toggle(
            'disabled',
            disable
          );

        }
      );

  }


  /**
   * ----------------------------------------------------------
   * GET CURRENT SECTION
   * ----------------------------------------------------------
   */

  static getSections() {

    const productGrid =
      document.getElementById(
        'product-grid'
      );


    if (!productGrid) {
      return [];
    }


    return [
      {
        section:
          productGrid.dataset.id
      }
    ];

  }


  /**
   * ----------------------------------------------------------
   * RENDER PAGE
   * ----------------------------------------------------------
   */

  static renderPage(
    searchParams,
    event,
    updateURLHash = true
  ) {

    /*
     * Always normalize the parameters.
     */

    if (
      searchParams instanceof
      URLSearchParams
    ) {

      searchParams =
        searchParams.toString();

    }


    searchParams =
      searchParams || '';


    FacetFiltersForm.searchParamsPrev =
      searchParams;


    const sections =
      FacetFiltersForm.getSections();


    if (!sections.length) {
      return;
    }


    const productGrid =
      document.getElementById(
        'ProductGridContainer'
      );


    if (productGrid) {

      const collection =
        productGrid.querySelector(
          '.collection'
        );


      if (collection) {

        collection.classList.add(
          'loading'
        );

      }

    }


    const countContainers =
      document.getElementsByClassName(
        'thb-filter-count'
      );


    for (
      const item of countContainers
    ) {

      item.classList.add(
        'loading'
      );

    }


    /*
     * Keep only one request per section.
     */

    sections.forEach(
      (section) => {

        const query =
          searchParams
            ? `&${searchParams}`
            : '';


        const url =
          `${window.location.pathname}?section_id=${encodeURIComponent(
            section.section
          )}${query}`;


        const filterDataUrl =
          (element) =>
            element.url === url;


        const cached =
          FacetFiltersForm.filterData.find(
            filterDataUrl
          );


        if (cached) {

          FacetFiltersForm.renderSectionFromCache(
            filterDataUrl,
            event
          );

        } else {

          FacetFiltersForm.renderSectionFromFetch(
            url,
            event
          );

        }

      }
    );


    if (updateURLHash) {

      FacetFiltersForm.updateURLHash(
        searchParams
      );

    }

  }


  /**
   * ----------------------------------------------------------
   * FETCH SECTION
   * ----------------------------------------------------------
   */

  static renderSectionFromFetch(
    url,
    event
  ) {

    fetch(
      url,
      {
        headers: {
          'X-Requested-With':
            'XMLHttpRequest'
        }
      }
    )
      .then(
        (response) => {

          if (!response.ok) {

            throw new Error(
              `Facet request failed: ${response.status}`
            );

          }


          return response.text();

        }
      )
      .then(
        (responseText) => {

          const cacheEntry = {
            html:
              responseText,

            url
          };


          FacetFiltersForm.filterData =
            [
              ...FacetFiltersForm.filterData,
              cacheEntry
            ];


          FacetFiltersForm.renderFilters(
            responseText,
            event
          );


          FacetFiltersForm.renderProductGridContainer(
            responseText
          );


          FacetFiltersForm.renderProductCount(
            responseText
          );


          FacetFiltersForm.afterRender();


        }
      )
      .catch(
        (error) => {

          console.error(
            '[Toprico Facets] Filter request failed:',
            error
          );


          FacetFiltersForm.removeLoadingState();

        }
      );

  }


  /**
   * ----------------------------------------------------------
   * CACHE
   * ----------------------------------------------------------
   */

  static renderSectionFromCache(
    filterDataUrl,
    event
  ) {

    const cached =
      FacetFiltersForm.filterData.find(
        filterDataUrl
      );


    if (!cached) {
      return;
    }


    FacetFiltersForm.renderFilters(
      cached.html,
      event
    );


    FacetFiltersForm.renderProductGridContainer(
      cached.html
    );


    FacetFiltersForm.renderProductCount(
      cached.html
    );


    FacetFiltersForm.afterRender();

  }


  /**
   * ----------------------------------------------------------
   * PRODUCT GRID
   * ----------------------------------------------------------
   */

  static renderProductGridContainer(
    html
  ) {

    const container =
      document.getElementById(
        'ProductGridContainer'
      );


    if (!container) {
      return;
    }


    const parsedHTML =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );


    const newContainer =
      parsedHTML.getElementById(
        'ProductGridContainer'
      );


    if (!newContainer) {
      return;
    }


    /*
     * Replace only the product-grid
     * container contents.
     */

    container.innerHTML =
      newContainer.innerHTML;


    /*
     * Notify Toprico's custom Size filter.
     */

    document.dispatchEvent(
      new CustomEvent(
        'toprico:facets-rendered'
      )
    );


    /*
     * Also allow other theme components
     * to reinitialize after an AJAX update.
     */

    document.dispatchEvent(
      new CustomEvent(
        'facets:rendered'
      )
    );


    /*
     * Reinitialize any custom elements
     * inside the newly-rendered product grid.
     */

    if (
      typeof window.initializeProductCards ===
      'function'
    ) {

      window.initializeProductCards();

    }


    /*
     * Preserve the existing Reformation
     * scroll behavior.
     */

    const headerHeight =
      parseInt(
        getComputedStyle(
          document.documentElement
        )
          .getPropertyValue(
            '--header-height'
          ),
        10
      ) || 0;


    const top =
      container.getBoundingClientRect().top +
      document.documentElement.scrollTop -
      headerHeight -
      30;


    window.scrollTo({
      top,
      left: 0,
      behavior: 'smooth'
    });

  }


  /**
   * ----------------------------------------------------------
   * PRODUCT COUNT
   * ----------------------------------------------------------
   */

  static renderProductCount(
    html
  ) {

    const parsedHTML =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );


    const countHtml =
      parsedHTML.getElementById(
        'ProductCount'
      );


    const containers =
      document.getElementsByClassName(
        'thb-filter-count'
      );


    if (!countHtml) {

      for (
        const item of containers
      ) {

        item.classList.remove(
          'loading'
        );

      }

      return;

    }


    for (
      const item of containers
    ) {

      item.innerHTML =
        countHtml.innerHTML;


      item.classList.remove(
        'loading'
      );

    }

  }


  /**
   * ----------------------------------------------------------
   * RENDER FILTERS
   * ----------------------------------------------------------
   */

  static renderFilters(
    html,
    event
  ) {

    const parsedHTML =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );


    /*
     * Get BOTH desktop and mobile
     * filter instances.
     */

    const facetDetailsElements =
      parsedHTML.querySelectorAll(
        '#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row'
      );


    /*
     * Determine which facet initiated
     * the request.
     *
     * We don't need to skip it anymore.
     * Shopify's returned HTML contains
     * the correct active state.
     */

    facetDetailsElements.forEach(
      (sourceElement) => {

        const index =
          sourceElement.dataset.index;


        if (!index) {
          return;
        }


        /*
         * IMPORTANT:
         *
         * There can be TWO matching rows:
         *
         * Desktop
         * Mobile
         *
         * querySelector() only updated one.
         *
         * querySelectorAll() updates both.
         */

        document
          .querySelectorAll(
            `collapsible-row[data-index="${CSS.escape(
              index
            )}"]`
          )
          .forEach(
            (targetElement) => {

              /*
               * Don't replace the entire
               * collapsible-row element.
               *
               * Only replace its inner HTML,
               * preserving the existing element.
               */

              targetElement.innerHTML =
                sourceElement.innerHTML;

            }
          );

      }
    );


    /*
     * Active filters.
     */

    FacetFiltersForm.renderActiveFacets(
      parsedHTML
    );


    /*
     * Mobile result count.
     */

    FacetFiltersForm.renderAdditionalElements(
      parsedHTML
    );


    /*
     * Reinitialize drawer.
     */

    new FacetsToggle();


    /*
     * Reinitialize native facet controls
     * after replacing their HTML.
     */

    FacetFiltersForm.initializeFilterControls();


    /*
     * Reinitialize custom Size filter
     * after Shopify replaced filter HTML.
     */

    document.dispatchEvent(
      new CustomEvent(
        'toprico:facets-rendered'
      )
    );

  }


  /**
   * ----------------------------------------------------------
   * ACTIVE FACETS
   * ----------------------------------------------------------
   */

  static renderActiveFacets(
    html
  ) {

    const source =
      html.querySelector(
        '.active-facets'
      );


    if (!source) {
      return;
    }


    document
      .querySelectorAll(
        '.active-facets'
      )
      .forEach(
        (target) => {

          target.innerHTML =
            source.innerHTML;

        }
      );


    FacetFiltersForm.toggleActiveFacets(
      false
    );


    /*
     * Rebind dynamically replaced
     * remove-filter links.
     */

    document
      .querySelectorAll(
        'facet-remove'
      )
      .forEach(
        (element) => {

          if (
            typeof element.initialize ===
            'function'
          ) {

            element.initialize();

          }

        }
      );

  }


  /**
   * ----------------------------------------------------------
   * ADDITIONAL ELEMENTS
   * ----------------------------------------------------------
   */

  static renderAdditionalElements(
    html
  ) {

    const selectors = [
      '.mobile-filter-count'
    ];


    selectors.forEach(
      (selector) => {

        const source =
          html.querySelector(
            selector
          );


        if (!source) {
          return;
        }


        document
          .querySelectorAll(
            selector
          )
          .forEach(
            (target) => {

              target.innerHTML =
                source.innerHTML;

            }
          );

      }
    );

  }


  /**
   * ----------------------------------------------------------
   * FILTER COUNT INSIDE A FACET
   * ----------------------------------------------------------
   */

  static renderCounts(
    source,
    target
  ) {

    if (!source || !target) {
      return;
    }


    const sourceElement =
      source.querySelector(
        '.facets__selected'
      );


    const targetElement =
      target.querySelector(
        '.facets__selected'
      );


    if (
      sourceElement &&
      targetElement
    ) {

      targetElement.outerHTML =
        sourceElement.outerHTML;

    }

  }


  /**
   * ----------------------------------------------------------
   * NATIVE FILTER CONTROL INITIALIZATION
   * ----------------------------------------------------------
   */

    /**
   * ----------------------------------------------------------
   * TOPRICO MOBILE SORT
   * ----------------------------------------------------------
   */

  static initializeMobileSort() {

    document
      .querySelectorAll(
        '[data-toprico-mobile-sort]'
      )
      .forEach(
        (sortContainer) => {

          const select =
            sortContainer
              .closest(
                '.thb-filter-sort'
              )
              ?.querySelector(
                'select[name="sort_by"]'
              );


          if (!select) {
            return;
          }


          sortContainer
            .querySelectorAll(
              '[data-sort-value]'
            )
            .forEach(
              (button) => {

                if (
                  button.dataset.topricoSortBound ===
                  'true'
                ) {

                  return;

                }


                button.dataset.topricoSortBound =
                  'true';


                button.addEventListener(
                  'click',
                  () => {

                    const value =
                      button.dataset.sortValue;


                    if (!value) {
                      return;
                    }


                    /*
                     * Update Shopify's real
                     * sort_by field.
                     */

                    select.value =
                      value;


                    /*
                     * Update visual state.
                     */

                    sortContainer
                      .querySelectorAll(
                        '[data-sort-value]'
                      )
                      .forEach(
                        (item) => {

                          const selected =
                            item.dataset.sortValue ===
                            value;


                          item.classList.toggle(
                            'is-selected',
                            selected
                          );


                          item.setAttribute(
                            'aria-pressed',
                            selected
                              ? 'true'
                              : 'false'
                          );

                        }
                      );


                    /*
                     * Trigger the existing
                     * FacetFiltersForm logic.
                     *
                     * We do NOT create another
                     * AJAX implementation here.
                     */

                    select.dispatchEvent(
                      new Event(
                        'change',
                        {
                          bubbles: true
                        }
                      )
                    );

                  }
                );

              }
            );

        }
      );

  }
  static initializeFilterControls() {

    FacetFiltersForm.initializeMobileSort();

    /*
     * Native checkbox/radio inputs
     * are handled by the facet form's
     * input/change listeners.
     *
     * No individual binding is needed.
     */

    document
      .querySelectorAll(
        'select.facet-filters__sort'
      )
      .forEach(
        (select) => {

          /*
           * Prevent duplicate explicit
           * sort handlers.
           */

          if (
            select.dataset.topricoSortBound ===
            'true'
          ) {

            return;

          }


          select.dataset.topricoSortBound =
            'true';


          select.addEventListener(
            'change',
            (event) => {

              const form =
                event.target.closest(
                  'form'
                );


              if (!form) {
                return;
              }


              /*
               * Use the complete form state
               * so sorting never removes
               * active filters.
               */

              const formData =
                new FormData(
                  form
                );


              const params =
                new URLSearchParams(
                  formData
                );


              FacetFiltersForm.renderPage(
                params.toString(),
                event
              );

            }
          );

        }
      );

  }


  /**
   * ----------------------------------------------------------
   * AFTER AJAX RENDER
   * ----------------------------------------------------------
   */

  static afterRender() {

    /*
     * Native controls.
     */

    FacetFiltersForm.initializeFilterControls();


    /*
     * Facets drawer.
     */

    new FacetsToggle();


    /*
     * Notify custom Toprico integrations.
     */

    document.dispatchEvent(
      new CustomEvent(
        'toprico:facets-rendered'
      )
    );


    /*
     * Remove loading state.
     */

    FacetFiltersForm.removeLoadingState();

  }


  /**
   * ----------------------------------------------------------
   * REMOVE LOADING
   * ----------------------------------------------------------
   */

  static removeLoadingState() {

    const productGrid =
      document.getElementById(
        'ProductGridContainer'
      );


    if (productGrid) {

      const collection =
        productGrid.querySelector(
          '.collection'
        );


      if (collection) {

        collection.classList.remove(
          'loading'
        );

      }

    }


    document
      .querySelectorAll(
        '.thb-filter-count'
      )
      .forEach(
        (item) => {

          item.classList.remove(
            'loading'
          );

        }
      );

  }


  /**
   * ----------------------------------------------------------
   * URL
   * ----------------------------------------------------------
   */

  static updateURLHash(
    searchParams
  ) {

    const url =
      searchParams
        ? `${window.location.pathname}?${searchParams}`
        : window.location.pathname;


    history.pushState(
      {
        searchParams
      },
      '',
      url
    );

  }


  /**
   * ----------------------------------------------------------
   * FORM SUBMIT
   * ----------------------------------------------------------
   */

  onSubmitHandler(
    event
  ) {

    event.preventDefault();


    const form =
      event.target.closest(
        'form'
      );


    if (!form) {
      return;
    }


    const formData =
      new FormData(
        form
      );


    const searchParams =
      new URLSearchParams(
        formData
      );


    /*
     * Preserve the existing Toprico/
     * Reformation price behavior.
     */

    if (
      searchParams.get(
        'filter.v.price.gte'
      ) ===
      '0.00'
    ) {

      searchParams.delete(
        'filter.v.price.gte'
      );

    }


    /*
     * Remove maximum price when it
     * equals the actual slider maximum.
     */

    const priceSlider =
      document.querySelector(
        '.price_slider'
      );


    if (
      priceSlider &&
      searchParams.get(
        'filter.v.price.lte'
      )
    ) {

      const sliderMax =
        parseFloat(
          priceSlider.dataset.max
        );


      const selectedMax =
        parseFloat(
          searchParams.get(
            'filter.v.price.lte'
          )
        );


      if (
        Number.isFinite(
          sliderMax
        ) &&
        Number.isFinite(
          selectedMax
        ) &&
        selectedMax === sliderMax
      ) {

        searchParams.delete(
          'filter.v.price.lte'
        );

      }

    }


    FacetFiltersForm.renderPage(
      searchParams.toString(),
      event
    );

  }


  /**
   * ----------------------------------------------------------
   * ACTIVE FILTER REMOVE
   * ----------------------------------------------------------
   */

  onActiveFilterClick(
    event
  ) {

    event.preventDefault();


    FacetFiltersForm.toggleActiveFacets(
      true
    );


    const href =
      event.currentTarget.href || '';


    const queryIndex =
      href.indexOf('?');


    const url =
      queryIndex === -1
        ? ''
        : href.slice(
            queryIndex + 1
          );


    FacetFiltersForm.renderPage(
      url
    );

  }

}


/**
 * ------------------------------------------------------------
 * STATIC STATE
 * ------------------------------------------------------------
 */

FacetFiltersForm.filterData =
  [];


FacetFiltersForm.searchParamsInitial =
  window.location.search.slice(
    1
  );


FacetFiltersForm.searchParamsPrev =
  window.location.search.slice(
    1
  );


customElements.define(
  'facet-filters-form',
  FacetFiltersForm
);


FacetFiltersForm.setListeners();


/**
 * ------------------------------------------------------------
 * FACET REMOVE
 * ------------------------------------------------------------
 */

class FacetRemove extends HTMLElement {

  constructor() {

    super();

    this.initialize();

  }


  initialize() {

    this
      .querySelectorAll(
        'a'
      )
      .forEach(
        (item) => {

          if (
            item.dataset.facetRemoveBound ===
            'true'
          ) {

            return;

          }


          item.dataset.facetRemoveBound =
            'true';


          item.addEventListener(
            'click',
            (event) => {

              event.preventDefault();


              const form =
                this.closest(
                  'facet-filters-form'
                ) ||
                document.querySelector(
                  'facet-filters-form'
                );


              if (!form) {
                return;
              }


              form.onActiveFilterClick(
                event
              );

            }
          );

        }
      );

  }

}


customElements.define(
  'facet-remove',
  FacetRemove
);


/**
 * ------------------------------------------------------------
 * PRICE SLIDER
 * ------------------------------------------------------------
 */

class PriceSlider extends HTMLElement {

  constructor() {

    super();

  }


  connectedCallback() {

    const slider =
      this.querySelector(
        '.price_slider'
      );


    const amounts =
      this.querySelector(
        '.price_slider_amount'
      );


    if (
      !slider ||
      !amounts ||
      typeof noUiSlider ===
        'undefined'
    ) {

      return;

    }


    const form =
      this.closest(
        'facet-filters-form'
      ) ||
      document.querySelector(
        'facet-filters-form'
      );


    if (!form) {
      return;
    }


    /*
     * Destroy an existing instance
     * before Shopify reinitializes it.
     */

    if (
      slider.classList.contains(
        'noUi-target'
      ) &&
      slider.noUiSlider
    ) {

      slider.noUiSlider.destroy();

    }


    const min =
      parseFloat(
        slider.dataset.min
      ) || 0;


    const max =
      parseFloat(
        slider.dataset.max
      ) || 0;


    const minValue =
      parseFloat(
        slider.dataset.minValue
      );


    const maxValue =
      parseFloat(
        slider.dataset.maxValue
      );


    const args = {

      start: [
        Number.isFinite(
          minValue
        )
          ? minValue
          : min,

        Number.isFinite(
          maxValue
        )
          ? maxValue
          : max
      ],

      connect:
        true,

      step:
        10,

      direction:
        document.dir,

      range: {
        min,
        max
      }

    };


    noUiSlider.create(
      slider,
      args
    );


    slider.noUiSlider.on(
      'update',
      (values) => {

        const minInput =
          amounts.querySelector(
            '.field__input_min'
          );


        const maxInput =
          amounts.querySelector(
            '.field__input_max'
          );


        if (minInput) {

          minInput.value =
            values[0];

        }


        if (maxInput) {

          maxInput.value =
            values[1];

        }

      }
    );


    slider.noUiSlider.on(
      'change',
      () => {

        /*
         * Trigger the form input event
         * so ALL active filters + sort
         * values are submitted together.
         */

        const formElement =
          form.querySelector(
            'form'
          );


        if (!formElement) {
          return;
        }


        formElement.dispatchEvent(
          new Event(
            'input',
            {
              bubbles:
                true
            }
          )
        );

      }
    );

  }

}


/**
 * ------------------------------------------------------------
 * CUSTOM ELEMENT
 * ------------------------------------------------------------
 */

customElements.define(
  'price-slider',
  PriceSlider
);


/**
 * ------------------------------------------------------------
 * INITIAL LOAD
 * ------------------------------------------------------------
 */

window.addEventListener(
  'load',
  () => {

    new FacetsToggle();

    FacetFiltersForm.initializeFilterControls();


    /*
     * Initialize any already-present
     * facet-remove elements.
     */

    document
      .querySelectorAll(
        'facet-remove'
      )
      .forEach(
        (element) => {

          if (
            typeof element.initialize ===
            'function'
          ) {

            element.initialize();

          }

        }
      );


    /*
     * Notify Toprico Size Filter.
     */

    document.dispatchEvent(
      new CustomEvent(
        'toprico:facets-rendered'
      )
    );

  }
);